module.exports = __webpack_public_path__ + "img/tongli.fc2d1b6c.jpg";